import React, { useState, useEffect, useCallback, memo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'query-string';
import useCenter from 'app/hook/encarcenter/useCenter';
import CenterLocation from 'app/components/encarcenter/CenterLocation';
import CenterList from 'app/components/encarcenter/CenterList';
import CenterCategory from 'app/components/encarcenter/CenterCategory';
import LoadingBar from 'app/components/common/LoadingBar';
import HeadInfo from 'app/components/common/HeadInfo';
import { usePreloader } from 'app/hook/common/usePreloader';

function AdCenterListContainer() {
	const { centerList, getCenterData } = useCenter();
	const history = useHistory();
	const { search } = useLocation();
	const query = qs.parse(search);
	const current = query.location || '';
	const [loaded, setLoaded] = useState((centerList?.length > 0 && 'success') || 'pending');

	const location = [
		{ value: '', tab: '전체' },
		{ value: 'SEOUL', tab: '서울' },
		{ value: 'INCHEON,GYEONGGI', tab: '인천/경기' },
		{ value: 'DAEGU,GYEONGBUK', tab: '대구/경북' },
		{ value: 'DAEJEON,CHUNGBUK,CHUNGNAM', tab: '대전/충북/충남' },
		{ value: 'GWANGJU,JEONBUK,JEONNAM,JEONNAMGWANGJU', tab: '광주/전북/전남' },
		{ value: 'BUSAN,ULSAN,GYEONGNAM', tab: '부산/울산/경남' },
	];

	usePreloader(async () => {
		try {
			await getCenterData({
				location: current,
				limit: 1000,
				offset: 0,
				centerServiceTypes: 'DIAGNOSIS',
			});
			setLoaded('success');
		} catch (err) {
			console.log(`error: ${err}`);
			setLoaded('failure');
		}
	});

	useEffect(() => {
		if (loaded === 'pending') {
			(async () => {
				try {
					await getCenterData({
						location: current,
						limit: 1000,
						offset: 0,
						centerServiceTypes: 'DIAGNOSIS',
					});
					setLoaded('success');
				} catch (err) {
					console.log(`error: ${err}`);
					setLoaded('failure');
				}
			})();
		}
	}, [loaded, current, getCenterData]);

	const handleOnChange = useCallback(
		(loc) => {
			if (loaded !== 'pending') {
				history.replace(`?location=${loc}`);
				setLoaded('pending');
			}
		},
		[loaded, history],
	);

	const locationKorean = location.find((d) => d.value === current)?.tab || '';
	return (
		<>
			<h3 className="blind">진단센터</h3>
			<CenterCategory active="ad" />
			<CenterLocation
				current={current}
				locationData={location}
				onChange={handleOnChange}
			/>
			{loaded !== 'success' && (
				<LoadingBar
					area={loaded === 'failure'}
					areaStyle={loaded === 'failure' ? { padding: '100px 0', top: '0', left: '0', transform: 'none' } : null}
					theme="circle"
					state={loaded}
				/>
			)}
			{loaded !== 'failure' && (
				<>
					<HeadInfo
						headTitle={`엔카지점 ${locationKorean}`}
						metaDescription={`${location.map((d) => d.tab).toString()} 지역의 엔카지점입니다`}
					/>
					<h5 className="blind">{locationKorean || '전국'}</h5>
					<CenterList centersList={centerList} />
				</>
			)}
		</>
	);
}

export default memo(AdCenterListContainer);
